import { Meteor } from 'meteor/meteor';
import { Promise } from 'meteor/promise';

/**
 * Converts a Meteor method call into a Promise.
 *
 * @param {string} method - Te name of the method to call.
 * @param {any} myParameters - The parameters to pass to the method.
 * @returns {Promise<any>} The result of the method.
 */
export default (method, ...myParameters) =>
  new Promise((resolve, reject) => {
    Meteor.call(method, ...myParameters, (err, res) => {
      if (err) reject(err);
      resolve(res);
    });
  });
